import * as Geolib from "geolib";
import { Maybe } from "./util/maybe";
export const toNumber = (value) => {
    if (typeof value === "string") {
        return parseFloat(value);
    }
    return value;
};
export const parseLocation = (lat, lng) => {
    let parsedLat = null;
    let parsedLng = null;
    if (typeof lat === "string" || typeof lat === "number") {
        parsedLat = toNumber(lat);
    }
    if (typeof lng === "string" || typeof lng === "number") {
        parsedLng = toNumber(lng);
    }
    if (typeof parsedLat === "number" &&
        !isNaN(parsedLat) &&
        typeof parsedLng === "number" &&
        !isNaN(parsedLng)) {
        return Maybe.fromValue(makeLocation(parsedLat, parsedLng));
    }
    return Maybe.none();
};
export const makeLocation = (lat, lng) => ({
    loc: [toNumber(lng), toNumber(lat)],
});
export function isValidLocation(location) {
    if (location) {
        return (location.loc &&
            location.loc.length === 2 &&
            parseLocation(location.loc[1], location.loc[0]).hasValue);
    }
    return false;
}
export function getLocalizedDistance(locale, pos1, pos2) {
    const meters = getDistance(pos1, pos2);
    return locale.conversions.fromMeters(meters);
}
export function getDistanceLatLng(pos1, pos2) {
    return Math.abs(Geolib.getDistance({
        latitude: pos1.lat,
        longitude: pos1.lng,
    }, {
        latitude: pos2.lat,
        longitude: pos2.lng,
    }));
}
export function getDistance(pos1, pos2) {
    if (!pos1.loc) {
        throw "pos1 loc missing";
    }
    if (!pos2.loc) {
        throw "pos2 loc missing";
    }
    const a1 = {
        latitude: pos1.loc[1],
        longitude: pos1.loc[0],
    };
    const a2 = {
        latitude: pos2.loc[1],
        longitude: pos2.loc[0],
    };
    return Math.abs(Geolib.getDistance(a1, a2));
}
export function getBounds(pos) {
    var coords = (pos || []).map(x => ({ lat: x.loc[1], lng: x.loc[0] }));
    var result = Geolib.getBounds(coords);
    var bounds = [
        { lat: result.minLat, lng: result.minLng },
        { lat: result.maxLat, lng: result.maxLng },
    ];
    return bounds;
}
export function printableDistance(locale, pos1, pos2) {
    if (isValidLocation(pos1) && isValidLocation(pos2)) {
        const distance = getLocalizedDistance(locale, pos1, pos2);
        const suffix = distance === 1
            ? locale.strings.distanceUnit
            : locale.strings.distanceUnitPlural;
        return `${distance.toFixed(1)} ${suffix}`;
    }
    return "";
}
export function locationsEqual(pos1, pos2) {
    return (Math.abs(pos1.loc[1] - pos2.loc[1]) < Number.EPSILON &&
        Math.abs(pos1.loc[0] - pos2.loc[0]) < Number.EPSILON);
}
export const locationToCoordinates = (location) => ({
    lng: location.loc[0].toString(),
    lat: location.loc[1].toString(),
});
//# sourceMappingURL=location.js.map